import { render, staticRenderFns } from "./DetectedLabelExclusions.vue?vue&type=template&id=bf6d4374"
import script from "./DetectedLabelExclusions.vue?vue&type=script&lang=js"
export * from "./DetectedLabelExclusions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports